import "./TeethWhitening.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
import Projects from "./sections/Projects";
export default function TeethWhiteningPage() {
  return <div>
      <Header />
      <Hero />
      <Projects />
      <Footer />
    </div>;
}